import { render, staticRenderFns } from "./ServicesCategoryServices.vue?vue&type=template&id=716c6e04&scoped=true&"
import script from "./ServicesCategoryServices.vue?vue&type=script&lang=js&"
export * from "./ServicesCategoryServices.vue?vue&type=script&lang=js&"
import style0 from "./ServicesCategoryServices.vue?vue&type=style&index=0&id=716c6e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c6e04",
  null
  
)

export default component.exports